import { TimeoffRequestPromiseClient } from "protorepo-dev/generated/node/rto/timeoff_request_grpc_web_pb";
import AuthorizedGrpcClient from "./AuthorizedClient";

export { default as TimeoffApi } from "protorepo-dev/generated/node/rto/timeoff_request_pb";

export const client = new AuthorizedGrpcClient(TimeoffRequestPromiseClient)
  .client;
